import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { Header, MainColorButton } from "../../components";
import { bottomButton } from "../../common/styles";
import { closeWindow } from "../../utils/getLineProfile";

/**
 * 処方箋申込　[完了]
 * @returns
 */
const FinishedPrescription = () => {
  const [endY, setEndY] = useState(0);
  // Stateからデータ取得
  let location = useLocation();
  const [isReregistration, setIsReregistration] = useState(false);
  const [canceled, setCanceled] = useState(false);
  const message = useRef(false);

  useEffect(() => {
    // 最初にstate読み取りから再登録するかどうか
    setIsReregistration(location.state?.isReregistration ?? false);
    //メッセージをジャンプするかどうか
    message.current = location.state?.message ?? false;
    //処方箋はキャンセルされました
    setCanceled(location.state?.canceled ?? false);
  }, []);

  return (
    <div
      onTouchStartCapture={(e) => {
        setEndY(0);
      }}
      onTouchMoveCapture={(e) => {
        setEndY(e.touches[0].clientY);
      }}
      onTouchEndCapture={(e) => {
        if (endY !== 0) {
          e.stopPropagation();
        }
      }}
    >
      <Header title={isReregistration ? "再登録" : "処方箋申込　[完了]"} />
      <Box
        height="76vh"
        marginTop="12vh"
        width="95%"
        marginLeft="auto"
        marginRight="auto"
      >
        <Typography variant="h6" align="center">
          {isReregistration
            ? canceled
              ? "選択されたお申し込みは、取消されています。"
              : "再登録を受付しました。"
            : "処方箋の申込を受付しました。"}
        </Typography>
      </Box>
      <MainColorButton
        style={bottomButton}
        label="閉じる"
        onClick={() => closeWindow()}
      />
    </div>
  );
};

export default FinishedPrescription;
